import { Star, Dot, Squiggle } from "./doodles";

const Lead = () => (
  <span className="font-display text-base font-medium lowercase tracking-tight text-navy/55 md:text-xl">
    what if paper could
  </span>
);

const Chip = ({ className = "", children }) => (
  <span
    className={`whitespace-nowrap rounded-full border-2 border-navy px-5 py-2 font-display text-lg font-semibold uppercase tracking-tight md:px-7 md:py-2.5 md:text-2xl ${className}`}
  >
    {children}
  </span>
);

const Phrase = ({ className = "text-navy", children }) => (
  <span className={`whitespace-nowrap font-display text-3xl font-semibold tracking-tight md:text-5xl ${className}`}>
    {children}
  </span>
);

const Sep = ({ className = "text-navy/60" }) => (
  <Star className={`mx-2 h-4 w-4 shrink-0 md:mx-4 md:h-6 md:w-6 ${className}`} aria-hidden="true" />
);

function TickerSet() {
  return (
    <>
      <span className="flex items-center"><Lead /><Phrase className="ml-3">break taboos?</Phrase><Sep className="text-grape" /></span>
      <span className="flex items-center"><Chip className="bg-navy text-paper">What if paper could start conversations?</Chip><Sep className="text-blush" /></span>
      <span className="flex items-center"><Lead /><Phrase className="ml-3 text-grape">make us curious?</Phrase><Dot className="mx-3 h-3 w-3 text-skyblue md:mx-5 md:h-4 md:w-4" aria-hidden="true" /></span>
      <span className="flex items-center"><Chip className="bg-blush text-navy">What if paper could change how we learn?</Chip><Sep /></span>
      <span className="flex items-center"><Lead /><Phrase className="ml-3 text-blush">make us feel heard?</Phrase><Sep className="text-blush" /></span>
      <span className="flex items-center"><Chip className="bg-skyblue text-navy">What if paper could make space for feelings?</Chip><Sep className="text-navy" /></span>
      <span className="flex items-center"><Lead /><Phrase className="ml-3">change the conversation?</Phrase><Squiggle className="mx-3 w-14 text-navy/50 md:mx-5 md:w-20" aria-hidden="true" /></span>
      <span className="flex items-center"><Chip className="bg-grape text-navy">What if paper could make vulnerability easier?</Chip><Sep className="text-sunny" /></span>
    </>
  );
}

export default function Ticker() {
  return (
    <section data-testid="ticker-section" aria-label="What if paper could — ideas in motion" className="relative overflow-hidden py-5 md:py-8">
      <p className="sr-only">
        What if paper could break taboos, start conversations, make us curious, change how we learn, make us feel
        heard, make space for feelings, change the conversation, and make vulnerability easier?
      </p>
      <div className="ticker-band -ml-[6%] w-[112%] -rotate-[1.5deg] overflow-hidden border-y-2 border-navy bg-sunny py-4 md:py-6">
        <div className="ticker-track items-center" aria-hidden="true">
          <div className="flex items-center">
            <TickerSet />
          </div>
          <div className="flex items-center">
            <TickerSet />
          </div>
        </div>
      </div>
    </section>
  );
}
